var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuteButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.434,
    height: 48.433,
    viewBox: "0 0 48.434 48.433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    opacity: 0.997
  }, /*#__PURE__*/React.createElement("g", {
    id: "mic",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_8873",
    "data-name": "\\u9577\\u65B9\\u5F62 8873",
    width: 48.433,
    height: 48.433,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20329",
    "data-name": "\\u30D1\\u30B9 20329",
    d: "M16.136,28.44A8.136,8.136,0,0,0,24.271,20.3V10.135A8.136,8.136,0,0,0,8,10.135V20.3a8.136,8.136,0,0,0,8.136,8.135Z",
    transform: "translate(8.271 2.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_20330",
    "data-name": "\\u30D1\\u30B9 20330",
    d: "M33.474,12.034a2.034,2.034,0,0,0-4.068,0,10.169,10.169,0,0,1-20.339,0,2.034,2.034,0,0,0-4.068,0A14.237,14.237,0,0,0,17.2,26.108v4.23H12.912a1.81,1.81,0,0,0-1.81,1.81V32.6a1.81,1.81,0,0,0,1.81,1.81H25.563a1.81,1.81,0,0,0,1.81-1.81v-.447a1.81,1.81,0,0,0-1.81-1.81H21.271v-4.23A14.237,14.237,0,0,0,33.474,12.034Z",
    transform: "translate(5.169 10.279)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteButton);
export default __webpack_public_path__ + "static/media/muteButton.d35941e0d5df4561f910a8befc9585ad.svg";
export { ForwardRef as ReactComponent };